import { Flex, Title } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackIcon } from '@/assets/svg/BackIcon';

type BackButtonProps = {
  title: string;
};
export const BackButton = ({ title }: BackButtonProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Flex align="center" gap="xs">
      <BackIcon
        className="back-icon icon-pull-up"
        onClick={() => {
          if (location?.state?.clear) {
            navigate('/', { replace: true });
          } else if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
          } else {
            navigate('/', { replace: true });
          }
        }}
      />
      <Title className="no-margin text-overflow " fw={600} order={4} lineClamp={1}>
        {title}
      </Title>
    </Flex>
  );
};
